import * as React from "react";
import type { SVGProps } from "react";
const SvgDrawingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="drawing_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M853.312 690.368V333.632a128 128 0 1 0-163.008-162.944H333.632a128 128 0 1 0-163.008 162.944v356.736a128 128 0 1 0 163.008 162.944h356.672a128 128 0 1 0 163.008-162.944zm-42.688-519.68a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312zm-597.312 0a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312zm0 682.624a42.624 42.624 0 1 1 0-85.248 42.624 42.624 0 0 1 0 85.248zM690.304 768H333.632A128 128 0 0 0 256 690.368V333.632A128 128 0 0 0 333.632 256h356.672A128.064 128.064 0 0 0 768 333.632v356.736A128 128 0 0 0 690.368 768zm120.32 85.312a42.688 42.688 0 1 1 0-85.312 42.688 42.688 0 0 1 0 85.312z"
    />
  </svg>
);
export default SvgDrawingIcon;
